import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(getDataURLKey),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(guardarPizarraVentana);

import { select, call } from 'redux-saga/effects';
import * as Util from '../../util';
import { getPantallaProps // getId,
// getNumPagina,
// getNumPaginaIzquierda,
// getModo    
} from '../../selectors'; // import { getConfigLibro } from '../../../selectors/config-libro'

import { getDataURL } from '../../pizarra/selectors';
import { PANTALLA_VENTANA_ID } from '../../constantes'; // import {
//     activarEditor,
//     desactivarEditor
// } from '../../../pizarra/actions'

function getDataURLKey() {
  var pantallaProps, libroIdGuardado, numPaginaGuardado, numZonaGuardado, key;
  return _regeneratorRuntime.wrap(function getDataURLKey$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getPantallaProps, PANTALLA_VENTANA_ID);

        case 2:
          pantallaProps = _context.sent; // const { libroId, numPagina, numZona } = pantallaProps

          libroIdGuardado = pantallaProps.libroIdGuardado, numPaginaGuardado = pantallaProps.numPaginaGuardado, numZonaGuardado = pantallaProps.numZonaGuardado;
          key = Util.getKeyImagenUsuarioPantallaVentana(libroIdGuardado, numPaginaGuardado, numZonaGuardado);
          return _context.abrupt('return', key);

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
} // export function* activarEditorPizarraLibro() {
//     const keys = yield* getDataURLKeys();
//     const dataURL_izquierda = Util.getStorageData(keys[0]);
//     window.console.log("sagas libro.pizarra.pizarra-libro.activarEditorPizarraLibro dataKey: " + keys[0])
//     const dataURL_derecha = Util.getStorageData(keys[1]);    
//     window.console.log("sagas libro.pizarra.pizarra-libro.activarEditorPizarraLibro dataKey: " + keys[1])
//     if (keys.length === 1) {                
//         yield put(activarEditor(dataURL_izquierda));    
//     } else {
//         const img = document.createElement('img');
//         const configLibro = yield select(getConfigLibro);
//         const dimensionesBaja = configLibro.dimensionesBaja;
//         const canvas = document.createElement('canvas');
//         canvas.width = dimensionesBaja.w * 2;
//         canvas.height = dimensionesBaja.h;
//         const ctx = canvas.getContext('2d');
//         if (dataURL_izquierda) {
//             img.src = dataURL_izquierda;
//             ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, img.naturalWidth, img.naturalHeight);
//         }
//         if (dataURL_derecha) {
//             img.src = dataURL_derecha;
//             ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, canvas.width / 2, 0, img.naturalWidth, img.naturalHeight);
//         }
//         yield put(activarEditor(canvas.toDataURL()));
//     }
// }


export function guardarPizarraVentana() {
  var dataURL, key;
  return _regeneratorRuntime.wrap(function guardarPizarraVentana$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(getDataURL);

        case 2:
          dataURL = _context2.sent;
          _context2.next = 5;
          return call(getDataURLKey);

        case 5:
          key = _context2.sent;
          Util.setStorageData(key, dataURL);

        case 7:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
} // export function* borrarPizarraLibro() {
//     const keys = yield getDataURLKeys()
//     keys.forEach( key => Util.removeStorageData(key))
// }
// export function* desactivarEditorPizarraLibro() {    
//     yield* guardarPizarraLibro()
//     yield put(desactivarEditor())
// }